export default __webpack_public_path__ + "3af4ccbf996599f5bd73062b1611b566.svg";